'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils/cn';
import { dividerTheme } from './theme';
export const Divider = ({ color = 'secondary', size = 'md', variant = 'center', className, children, ...props }) => {
    const { withChildren, withOutChildren } = dividerTheme;
    if (!children) {
        return (_jsx("hr", { ...props, className: cn(withOutChildren.base, withOutChildren.size[size], withOutChildren.color[color], className) }));
    }
    return (_jsx("div", { ...props, className: cn(withChildren.base, withChildren.textColor[color], withChildren.variant[variant], withChildren.color[variant][color], withChildren.size[variant][size], className), children: children }));
};
